import Heading from "./heading.js";
import Description from "./description.js";

function about() {
  return (
    <div>
        <Heading />
        <Description />
    </div>
    
  );
}


export default about;